module.exports = __webpack_public_path__ + "images/sprites/ui/icon_input_selectebox_80a4cb1247ef143763adfb5497656cfb.png";